import { useCallback, useState } from 'react';

import { useTextLines } from './useTextLines';

/**
 * WARNING: do not use padding or border on the ref element it can affect calculation
 */
export const useClampText = <Element extends HTMLElement>({
  lines = 4,
}: { lines?: number } = {}) => {
  const [ref, linesState] = useTextLines<Element>();
  const [isClamped, setIsClamped] = useState(true);
  const canClamp = !!linesState && linesState.totalLines > lines;
  const isCollapsed = canClamp && isClamped;
  const isExpanded = canClamp && !isClamped;

  const toggle = useCallback(() => {
    setIsClamped((oldState) => !oldState);
  }, []);

  return {
    ref,
    linesState,
    isClamped,
    setIsClamped,
    canClamp,
    isCollapsed,
    isExpanded,
    toggle,
  };
};
